// import React, { useState } from "react";
// import { Link } from "react-router-dom";

// import img1 from "../Assessts/Events/ficci1.png";
// import img2 from "../Assessts/Events/ficci.jpg";
// import img3 from "../Assessts/Events/img2.jpg";
// import img4 from "../Assessts/Events/Ficci2.jpg";
// import img5 from "../Assessts/Events/AnnualGeneralMeeting.png";
// import img6 from "../Assessts/Events/5AnnualSummit.png";

// import "./EventsExabtionss.css";

// export default function EventsExabtionss() {
//   const events = [
//     {
//       id: 1,
//       image: img1,
//       title:
//         "TAAD Exhibition at Bharat Mandapam, Delhi (Booth 2.87, 15–17 Oct 2025)",
//       description: `
// Technocrat Aerospace and Defence (TAAD) proudly participated in the Defence & Aerospace Exhibition 
// held at Bharat Mandapam, Pragati Maidan, New Delhi. 
// We showcased our latest innovations, products, and cutting-edge defence solutions. 
// The event offered excellent opportunities for networking and collaboration with industry leaders.
//       `,
//     },
//     {
//       id: 2,
//       image: img2,
//       title:
//         "Strategic Project Discussion and Collaboration with Indian Navy at FICCI, New Delhi",
//       description: `
// TAAD participated in a high-level strategic meeting organized at FICCI, New Delhi. 
// Discussions focused on defence innovation, naval modernization, and long-term collaboration. 
// Our team presented key capabilities aligned with Indian Navy’s operational needs. 
// This strengthened our commitment toward supporting India's maritime defence ecosystem.
//       `,
//     },
//     {
//       id: 3,
//       image: img3,
//       title:
//         "TAAD Participation in State-Level DTTC MSME Capacity Building Conference with DRDO",
//       description: `
// TAAD was honored to join the DRDO-led DTTC MSME Capacity Building Conference. 
// The event created opportunities for MSMEs in defence R&D and manufacturing. 
// We shared insights on indigenous technology development and innovation. 
// This strengthened our support toward India’s ‘Aatmanirbhar Bharat’ mission.
//       `,
//     },
//     {
//       id: 4,
//       image: img4,
//       title: "FICCI 98th AGM at Taj Mahal Hotel, New Delhi",
//       description: `
// TAAD attended the prestigious 98th Annual General Meeting organized by FICCI. 
// The event hosted leaders from government, defence, and major industries. 
// Our team held insightful discussions on industrial development and defence growth. 
// It opened doors for impactful collaboration with top policymakers.
//       `,
//     },
//     {
//       id: 5,
//       image: img5,
//       title: "FICCI 98th AGM – Interaction with Industry Leaders",
//       description: `
// TAAD engaged in meaningful discussions with Shri Piyush Goyal (Hon’ble Minister of Commerce & Industry), 
// Shri Rajesh Kumar Singh (Secretary, Ministry of Defence), Mr. Anant Goenka (Vice Chairman, RPG Group), Shri. Amardeep Singh Bhatiya ( Secretary, DPIIT) ,
// Mr. Harshvardhan Agarwal (CMD, Emami Limited), Mr. Shehzad Poonawalla (National Spokesperson, BJP), 
// and other distinguished leaders on India's industrial growth and self-reliant economy.
//       `,
//     },
//     {
//       id: 6,
//       image: img6,
//       title: "Attended the CII Annual Business Summit 2025 in New Delhi, engaging with India’s top defence ",
//       description: `
// Attended the CII Annual Business Summit 2025 in New Delhi, engaging with India’s top defence and government leadership on strengthening indigenous capabilities, technology-driven growth and the “Building Trust – India First” vision. Met Chief of Air Staff Air Chief Marshal A P Singh, Defence Secretary Shri Rajesh Kumar Singh, DRDO Chief Dr Samir V Kamat, Union Minister Shri Ashwini Vaishnaw and senior officials from multiple ministries to explore deeper industry–government collaboration in defence, railways and digital infrastructure.
//       `,
//     },
//   ];

//   const [startIndex, setStartIndex] = useState(0);
//   const total = events.length;

//   const handleNext = () => setStartIndex((prev) => (prev + 1) % total);
//   const handlePrev = () => setStartIndex((prev) => (prev - 1 + total) % total);

//   // Show 3 items in a loop
//   const visibleEvents = [
//     events[startIndex],
//     events[(startIndex + 1) % total],
//     events[(startIndex + 2) % total],
//   ];

//   return (
//     <div className="events-wrapper">
//       <h2 className="events-heading">Events & Exhibitions</h2>

//       <div className="events-carousel-container">
//         {/* Left Navigation */}
//         <button className="nav-btn nav-btn-left" onClick={handlePrev}>
//           ‹
//         </button>

//         {/* Carousel */}
//         <div className="events-carousel">
//           <div className="events-inner">
//             {visibleEvents.map((event, index) => (
//               <div
//                 className="event-card event-card-slide"
//                 key={`${event.id}-${index}`}
//               >
//                 <img
//                   src={event.image}
//                   alt={event.title}
//                   className="event-image"
//                 />

//                 <div className="event-content">
//                   <h4 className="event-title">{event.title}</h4>

//                   <Link
//                     to={`/event/${event.id}`}
//                     state={{ event }}
//                     className="event-link"
//                   >
//                     Read More →
//                   </Link>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* Right Navigation */}
//         <button className="nav-btn nav-btn-right" onClick={handleNext}>
//           ›
//         </button>
//       </div>
//     </div>
//   );
// }



import React, { useState } from "react";
import { Link } from "react-router-dom";



import img1 from "../Assessts/Events/ficci1.png";
import img2 from "../Assessts/Events/ficci.jpg";
import img3 from "../Assessts/Events/img2.jpg";
import img4 from "../Assessts/Events/Ficci2.jpg";
import img5 from "../Assessts/Events/AnnualGeneralMeeting.png";
import img6 from "../Assessts/Events/5AnnualSummit.png";


//dttc 
import imgs1 from "../Assessts/Events/subimages/1dttc.png";
import imgs2 from "../Assessts/Events/subimages/2dttc.png";
import imgs3 from "../Assessts/Events/subimages/3dttc.png";
import imgs4 from "../Assessts/Events/subimages/4dttc.png";

//cii

import imgs5 from "../Assessts/Events/subimages/cii1.png";
import imgs6 from "../Assessts/Events/subimages/cii2.png";
import imgs7 from "../Assessts/Events/subimages/cii3.png";
import imgs8 from "../Assessts/Events/subimages/4cii.png";

// baumer 1
import imgs9 from "../Assessts/Events/subimages/1baumer.png";
import imgs10 from "../Assessts/Events/subimages/2baumer.png";
import imgs11 from "../Assessts/Events/subimages/3baumer.png";
import imgs12 from "../Assessts/Events/subimages/4baumer.png";

// navy 2
import imgs13 from "../Assessts/Events/subimages/3navy.png";
import imgs14 from "../Assessts/Events/subimages/2navy.png";

// tajmahal piyush 
import imgs17 from "../Assessts/Events/subimages/1taj.png";
import imgs18 from "../Assessts/Events/subimages/2taj.png";
import imgs19 from "../Assessts/Events/subimages/3taj.png";
import imgs20 from "../Assessts/Events/subimages/4taj.png";

//industry leaders - 


import imgs21 from "../Assessts/Events/subimages/1leader.png";
import imgs22 from "../Assessts/Events/subimages/2leader.png";




import "./EventsExabtionss.css";
  
export default function EventsExabtionss() {
  const events = [
    {
      id: 1,
      image: img1,
      title:
        "TAAD Exhibition at Bharat Mandapam, Delhi (Booth 2.87, 15–17 Oct 2025)",
      description: `
Technocrat Aerospace and Defence (TAAD) proudly participated in the Defence & Aerospace Exhibition 
held at Bharat Mandapam, Pragati Maidan, New Delhi. 
We showcased our latest innovations, products, and cutting-edge defence solutions. 
The event offered excellent opportunities for networking and collaboration with industry leaders.
      `,
        extraImages: [imgs9, imgs10, imgs11, imgs12],
    },
    {
      id: 2,
      image: img2,
      title:
        "Strategic Project Discussion and Collaboration with Indian Navy at FICCI, New Delhi",
      description: `
TAAD participated in a high-level strategic meeting organized at FICCI, New Delhi. 
Discussions focused on defence innovation, naval modernization, and long-term collaboration. 
Our team presented key capabilities aligned with Indian Navy’s operational needs. 
This strengthened our commitment toward supporting India's maritime defence ecosystem.
      `,
        extraImages: [imgs13, imgs14],
    },
    {
      id: 3,
      image: img3,
      title:
        "TAAD Participation in State-Level DTTC MSME Capacity Building Conference with DRDO",
      description: `
TAAD was honored to join the DRDO-led DTTC MSME Capacity Building Conference. 
The event created opportunities for MSMEs in defence R&D and manufacturing. 
We shared insights on indigenous technology development and innovation. 
This strengthened our support toward India’s ‘Aatmanirbhar Bharat’ mission.
      `,
        extraImages: [imgs1, imgs2, imgs3, imgs4 ],
    },
    {
      id: 4 ,
      image: img4,
      title: "FICCI 98th AGM at Taj Mahal Hotel, New Delhi",
      description: `
TAAD attended the prestigious 98th Annual General Meeting organized by FICCI. 
The event hosted leaders from government, defence, and major industries. 
Our team held insightful discussions on industrial development and defence growth. 
It opened doors for impactful collaboration with top policymakers.
      `,
        extraImages: [imgs17, imgs18, imgs19, imgs20],
    },
    {
      id: 5,
      image: img5,
      title: "FICCI 98th AGM – Interaction with Industry Leaders",
      description: 
      `
TAAD engaged in meaningful discussions with Shri Piyush Goyal (Hon’ble Minister of Commerce & Industry), 
Shri Rajesh Kumar Singh (Secretary, Ministry of Defence), Mr. Anant Goenka (Vice Chairman, RPG Group), Shri. Amardeep Singh Bhatiya ( Secretary, DPIIT) ,
Mr. Harshvardhan Agarwal (CMD, Emami Limited), Mr. Shehzad Poonawalla (National Spokesperson, BJP), 
and other distinguished leaders on India's industrial growth and self-reliant economy.

      `,
        extraImages: [imgs21, imgs22],

    },
    {
      id: 6,
      image: img6,
      title: "Attended the CII Annual Business Summit 2025 in New Delhi, engaging with India’s top defence ",
      description:`
Attended the CII Annual Business Summit 2025 in New Delhi, engaging with India’s top defence and government leadership on strengthening indigenous capabilities, technology-driven growth and the “Building Trust – India First” vision. Met Chief of Air Staff Air Chief Marshal A P Singh, Defence Secretary Shri Rajesh Kumar Singh, DRDO Chief Dr Samir V Kamat, Union Minister Shri Ashwini Vaishnaw and senior officials from multiple ministries to explore deeper industry–government collaboration in defence, railways and digital infrastructure.
      `,
        extraImages: [imgs5, imgs6, imgs7, imgs8],
    },
    
  ];

  const [startIndex, setStartIndex] = useState(0);
  const total = events.length;

  const handleNext = () => setStartIndex((prev) => (prev + 1) % total);
  const handlePrev = () => setStartIndex((prev) => (prev - 1 + total) % total);

  // Show 3 items in a loop
  const visibleEvents = [
    events[startIndex],
    events[(startIndex + 1) % total],
    events[(startIndex + 2) % total],
  ];

  return (
    <div className="events-wrapper">
      <h2 className="events-heading">Events & Exhibitions</h2>

      <div className="events-carousel-container">
        {/* Left Navigation */}
        <button className="nav-btn nav-btn-left" onClick={handlePrev}>
          ‹
        </button>

        {/* Carousel */}
        <div className="events-carousel">
          <div className="events-inner">
            {visibleEvents.map((event, index) => (
              <div
                className="event-card event-card-slide"
                key={`${event.id}-${index}`}
              >
                <img
                  src={event.image}
                  alt={event.title}
                  className="event-image"
                />

                <div className="event-content">
                  <h4 className="event-title">{event.title}</h4>

                  <Link
                    to={`/event/${event.id}`}
                    state={{ event }}
                    className="event-link"
                  >
                    Read More →
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Right Navigation */}
        <button className="nav-btn nav-btn-right" onClick={handleNext}>
          ›
        </button>
      </div>
    </div>
  );
}
